import { titles } from "constants/titles";

// Field configuration for ChangePassword screen
export const FIELD_CONFIG = {
  currentPassword: {
    title: titles?.current_password,
    validation: {
      required: true,
      minLength: 8,
      customMessage: "Current Password must be minimum 8 characters"
    }
  },
  newPassword: {
    title: titles?.new_password,
    validation: {
      required: true,
      minLength: 8,
      customMessage: "New Password must be minimum 8 characters"
    }
  },
  confirmPassword: {
    title: titles?.confirm_new_password,
    validation: {
      required: true,
      minLength: 8,
      customMessage: "Confirm Password must be minimum 8 characters",
      matchField: 'newPassword',
      matchMessage: "New password and Confirm new password should be same"
    }
  }
};

// Generate validation fields object from config
export const VALIDATION_FIELDS = Object.keys(FIELD_CONFIG).reduce((acc, key) => {
  acc[key] = false;
  return acc;
}, {});
